import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { MessageResponse } from '../_models/responses';

export interface Complaint {
  id?: number;
  name_complainant: string;
  address_complainant: string;
  complainant_phone_id?: number;
  complainant_fax_no_id?: number;
  complainant_email: string;
  complainant_strata_plan_no?: string;
  name_complainee: string;
  address_complainee: string;
  complainee_phone_id?: number;
  complainee_fax_no_id?: number;
  complainee_email: string;
  complainee_strata_plan_no?: string;
  complainee_section_strata_lotno: string;
  complainant_type: string;
  complainant_section_strata_lotno: string;
  complainant_section_strata_planno?: string;
  grounds_complaint: string;
  status: string;
  date_submission: string;
  propertyId: number;
}

@Injectable({ providedIn: 'root' })
export class ComplaintService {
  constructor(private http: HttpClient) {}

  getComplaintsByPropertyId(propertyId: number) {
    return this.http.get<Complaint[]>(`${environment.apiUrl}/api/complaint/property/${propertyId}`);
  }

  getComplaintsByComplainantLotNo(propertyId: number, complainantLotNo: string) {
    return this.http.get<Complaint[]>(`${environment.apiUrl}/api/complaint/property/${propertyId}/complainant/${complainantLotNo}`);
  }

  getComplaintsByComplaineeLotNo(propertyId: number, complaineeLotNo: string) {
    return this.http.get<Complaint[]>(`${environment.apiUrl}/api/complaint/property/${propertyId}/complainee/${complaineeLotNo}`);
  }

  getComplaint(complaintId: number) {
    return this.http.get<Complaint>(`${environment.apiUrl}/api/complaint/${complaintId}`);
  }

  createComplaint(request: any) {
    let header = new HttpHeaders();
    header = header.append('content-type', 'application/json');

    return this.http.post<MessageResponse>(`${environment.apiUrl}/api/complaint`, request, { headers: header });
  }

  updateComplaint(complaintId: number, request: any) {
    return this.http.put<MessageResponse>(`${environment.apiUrl}/api/complaint/${complaintId}`, request);
  }

  deleteComplaint(complaintId: number) {
    return this.http.delete<MessageResponse>(`${environment.apiUrl}/api/complaint/${complaintId}`);
  }
}
